module.exports = [{"name":"Booster cables","quantity":1,"perishable":false,"shareable":true}]


//////////////////
// WEBPACK FOOTER
// ./src/basekits/addons/vehicle.json
// module id = 296
// module chunks = 0